import { FC, useMemo } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'

import { getFormattedFinance } from '../../../../../../../helpers/getFormattedFinance'
import { ITranslationsProps, ITurnoverProps } from '../../models/turnoverProps'

import styles from './TurnoverReadMode.module.scss'

export const TurnoverReadMode: FC<
  ITranslationsProps & Omit<ITurnoverProps, 'isLargeFormatMode'>
> = ({ turnover, ppsShare, turnoverLabelKey = '', ppsShareLabelKey = '' }) => {
  const formattedTurnoverValue = useMemo(() => {
    if (turnover === null) {
      return '-'
    }

    const formattedFinValue = getFormattedFinance(turnover, {
      withCurrencySign: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })

    return `${formattedFinValue}M`
  }, [turnover])

  const ppsSharePercentValue = useMemo(() => {
    if (ppsShare === null) {
      return '-'
    }

    return `${ppsShare}%`
  }, [ppsShare])

  return (
    <div className={styles.root}>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{formattedTurnoverValue}</div>
        <div className={styles.label}>
          <Translation text={turnoverLabelKey} span />
        </div>
      </div>
      <div className={styles.fieldWrapper}>
        <div className={styles.value}>{ppsSharePercentValue}</div>
        <div className={styles.label}>
          <Translation text={ppsShareLabelKey} span />
        </div>
      </div>
    </div>
  )
}
